"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "m22.794 19.666-4.962-6.32a.965.965 0 0 0-.65-.37.979.979 0 0 0-.72.21l-2.2 1.78-4.102-5.01 2.301-1.88c.42-.34.49-.97.15-1.39L7.638.376a.965.965 0 0 0-.65-.37.979.979 0 0 0-.72.21l-3.28 2.66c-.17.14-.29.33-.34.55l-1.62 7.12a.97.97 0 0 0 .2.85l9.862 12.24c.19.23.46.36.76.36l6.913-.07c.22 0 .43-.08.6-.22l3.271-2.66c.42-.34.49-.97.15-1.39l.01.01Zm-2.43.67-1.732 1.41c-.14.11-.389.2-.569.2l-5.412.05c-.18 0-.41-.11-.52-.25l-8.853-10.98a.75.75 0 0 1-.13-.56l1.3-5.69c.04-.17.18-.4.32-.51l1.691-1.37a.319.319 0 0 1 .45.05l3.32 4.22c.11.14.09.34-.05.45l-1.04.85c-.14.11-.34.31-.45.45 0 0-.47.57-.52 1.1-.05.53.29 1.18.29 1.18.08.16.24.39.35.53l3.702 4.52c.11.14.32.33.46.44 0 0 .71.54 1.291.54.44 0 .98-.29.98-.29.15-.08.39-.24.53-.36l.89-.72a.319.319 0 0 1 .451.05l3.31 4.22c.11.14.09.34-.05.45l-.01.02Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M23 3.09a1.09 1.09 0 0 1-.32.735l-4.154 4.066h1.505c.556 0 1.006.472 1.006 1.054 0 .583-.451 1.055-1.006 1.055h-4.037l-.06-.003C15.412 9.959 15 9.502 15 8.945V4.727c0-.582.451-1.054 1.006-1.054.556 0 1.006.472 1.006 1.054v1.76l4.296-4.203a.974.974 0 0 1 1.422.051c.183.208.279.478.27.755Z"
  })]
});